export default {
  error: 'Error',
  sorry: 'Lo sentimos, hemos recibido el siguiente error',
  workingOnIt:
    'Un ingeniero ha sido notificado de este problema y estamos trabajando para resolverlo lo más rápido posible.',
  tryAgain: 'Por favor, inténtelo de nuevo más tarde',
  noInternet:
    'Parece que hay un problema con tu conexión a internet. Por favor revise e intenta de nuevo.',
}
